import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SemLeftMenuComponent } from '../../components/sem-left-menu/sem-left-menu.component';
import { SemHeaderMenuComponent } from '../../components/sem-header-menu/sem-header-menu.component';
import { RequestModel } from '../../../models/request/request-model';
import { RouterModule, Routes, Router, RouterLink, UrlSerializer } from '@angular/router';
import { CustomUrlSerializer } from '../../../shared/helpers/custom-url-serializer';
import { MenuTypePipe } from '../../pipes/menu-type-pipe';
import { SemBreadcrumbComponent } from '../../components/sem-breadcrumbs/sem-breadcrumbs.component';
import { SemLeftMenuItemComponent } from '../../components/sem-left-menu-item/sem-left-menu-item.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { WgSidebarComponent } from '../../components/wg-sidebar/wg-sidebar.component';
import { WgHeaderComponent } from '../../components/wg-header/wg-header.component';
import { WgMetadataPanelComponent } from '../../components/wg-metadata-panel/wg-metadata-panel.component';
import { WgAiPanelComponent } from '../../components/wg-ai-panel/wg-ai-panel.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgScrollbarModule,
    WgSidebarComponent,
    WgHeaderComponent,
    WgMetadataPanelComponent,
    WgAiPanelComponent
  ],
  declarations: [
    SemLeftMenuComponent,
    SemHeaderMenuComponent,
    SemBreadcrumbComponent,
    MenuTypePipe,
    SemLeftMenuItemComponent
  ],
  exports: [
    SemLeftMenuComponent,
    SemHeaderMenuComponent,
    SemBreadcrumbComponent,
    SemLeftMenuItemComponent,
    WgSidebarComponent,
    WgHeaderComponent,
    WgMetadataPanelComponent,
    WgAiPanelComponent
  ],
  providers: [RequestModel,[{ provide: UrlSerializer, useClass: CustomUrlSerializer }]],
})
export class SemNavigationModule { }
